import { axiosInstance } from "../axios/axiosConfig";
import { QUIZ_API } from "../constants/api-constants";

export const getQuizItem = async () => {
  try {
    const response = await axiosInstance.get(QUIZ_API.GET_QUIZ_FREE_TEST_API);
    const freeTestId = response.data;
    if (freeTestId > 0) {
      const response = await axiosInstance.get(`${QUIZ_API.GET_QUIZ_ITEM_API}/${freeTestId}/QuestionOfQuiz`);

      return {
        quizId: freeTestId,
        data: response.data,
      };
    }
    return null;
  } catch (error) {
    throw new Error(QUIZ_API.GET_FREE_QUIZ_API_ERROR);
  }
};

export const postFreeQuizAnswer = async (quizId, data) => {
  try {
    const response = await axiosInstance.post(`${QUIZ_API.GET_QUIZ_ITEM_API}/${quizId}/learner/submit`, data);
    return response.data;
  } catch (error) {
    throw new Error(QUIZ_API.POST_QUIZ_ANSWER_API_ERROR);
  }
};

export const getListTopik = async (body, params) => {
  try {
    const response = await axiosInstance.post(`${QUIZ_API.GET_TOPIK_QUIZ_API}`, body, { params });
    return response.data;
  } catch (error) {
    throw new Error(QUIZ_API.GET_FREE_QUIZ_API_ERROR);
  }
};

export const getQuizQuestionDetail = async (id) => {
  try {
    const response = await axiosInstance.get(`${QUIZ_API.GET_QUIZ_ITEM_API}/${id}/QuestionOfQuiz`);
    return response.data;
  } catch (error) {}
};
export const getQuiz = async (id) => {
  try {
    const response = await axiosInstance.get(`${QUIZ_API.GET_QUIZ_ITEM_API}/${id}`);
    return response.data;
  } catch (error) {}
};

export const getQuizResultDetail = async (id) => {
  try {
    const response = await axiosInstance.get(`${QUIZ_API.GET_QUIZ_RESULT_DETAIL_API}/${id}`);
    return response.data;
  } catch (error) {
    throw new Error(QUIZ_API.GET_FREE_QUIZ_API_ERROR);
  }
};

export const getHighestScore = async (quizId) => {
  try {
    const response = await axiosInstance.get(`${QUIZ_API.GET_HIGHEST_SCORE}/${quizId}`);
    return response.data;
  } catch (error) {
    throw new Error(QUIZ_API.GET_FREE_QUIZ_API_ERROR);
  }
};

export const getTopikTestResultDetailByUserId = async () => {
  try {
    const response = await axiosInstance.get(`${QUIZ_API.GET_TOPIK_TEST_RESULT_DETAIL}`);
    return response.data;
  } catch (error) {}
};

export const getPretestResultById = async (id) => {
  try {
    const response = await axiosInstance.get(`${QUIZ_API.GET_RESULT_HISTORY}/${id}`);
    return response.data;
  } catch (error) {}
};

export const getTopikTestList = async () => {
  try {
    const response = await axiosInstance.get(QUIZ_API.GET_TOPIK_TEST_LIST);
    return response.data;
  } catch (error) {}
};

export const sendGuestOtp = async (email, language) => {
  const response = await axiosInstance.post("/pre-test/guest/send-otp", { email, language });
  return response.data;
};

export const verifyGuestOtp = async (email, code) => {
  const response = await axiosInstance.post("/pre-test/guest/verify-otp", { email, code });
  return response.data;
};

export const associateGuestEmail = async (publicId, email) => {
  const response = await axiosInstance.patch(`/QuizResultHistories/${publicId}/guest-email`, { email });
  return response.data;
};
